import React from "react"
import { Col, Container, Row } from "reactstrap"
import DoubleArrowButton from "../../../../../components/common/DoubleArrowButton/DoubleArrowButton"

const PolicyGuidelines = () => {
  const data = [
    {
      label: "Time Frame:",
      value: "Within 30 days of delivery",
    },
    {
      label: "Condition:",
      value: "Original condition and packaging",
    },
    {
      label: "Exceptions:",
      value: "Perishable goods, personalized items",
    },
  ]

  return (
    <Container fluid>
      <h4 className="fw-semibold my-3">Policy Guidelines</h4>
      <h5 className="fw-semibold my-3">Eligibility</h5>

        <Row className="g-0">
          <Col xs="12" lg="7" className="bg-white rounded p-3">
            {data.map(({ label, value }) => (
              <Row style={{ fontSize: "1.25rem" }}>
                <Col xs="3">{label}</Col>
                <Col xs="9" style={{ color: "#EC7426" }}>
                  {value}
                </Col>
              </Row>
            ))}
          </Col>
        </Row>

      <h5 className="fw-semibold my-3">Return and Refund Policy</h5>
      <DoubleArrowButton name='View Return/Refund Policy' />

    </Container>
  )
}

export default PolicyGuidelines
